import React, {useContext, useEffect, useState} from 'react'
import {SessionContext} from 'Utils/sessions';
import s from './styles/Dashboard.module.scss'
import SideBar from 'Components/Nav/SideBar';
import {setSessionCookie} from "../Utils/sessions";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import {AdminApi} from "../Api/AdminApi";

const UserDashboard = () => {
    const {session} =  useContext(SessionContext);
    const [schedulePageData, setSchedulePageData] = useState(null);
    const userTableHeader = ['ID', 'First Name', 'Last Name', 'Email', 'Student Type', 'School', 'Verified']
    const [resetFilter, setResetFilter] = useState(false)
    const [filerOpen, setFilterOpen] = useState(false)
    const [topic, setTopic] = useState('')

    useEffect(() => {
        if (resetFilter) {
            setTopic('')
        }
    }, [resetFilter])

    function toggleFilter() {
        setFilterOpen(!filerOpen)
    }

    function updateTopic(e) {
        setTopic(e?.target?.value.replaceAll(' ', '-'))
        setFilterOpen(false)
    }

    useEffect(() => {
        // AdminApi.User.getAdminPageScheduleData({}, session.jwt).then(res => {
        //     setSchedulePageData(res.data);
        // }).catch(error => {
        //     if (error.message?.includes( '404')) {
        //         setSessionCookie({})
        //         window.location.href = window.location.hostname
        //     }
        // })
    }, [session.jwt])

    return <div>
        <SideBar session={session} title={"Schedule"}>
            <div className={s.adminDashboard}>
                <main className={s.dataSection}>
                    <h3 className='heading'>Meetings</h3>
                    <div className={s.dataTableContainer}>

                    </div>
                </main>
                <aside className={s.filterSection}>
                    <Card className={s.filterCard}>
                        <Card.Title className={s.filterCardHeader}>
                            <div className={s.filterCardTitle}>Meetings</div>
                        </Card.Title>
                        <Card.Body className={'my-1'}>
                        <div><strong>Total:</strong> {schedulePageData?.meetings?.length ?? 0}</div>
                            <div><strong>Meeting Requests:</strong> {schedulePageData?.meetings?.filter(meeting => meeting.status === 'PENDING')?.length ?? 0}</div>
                            <div><strong>Scheduled Meetings:</strong> {schedulePageData?.meetings?.filter(meeting => meeting.status === 'PENDING')?.length ?? 0}</div>
                        </Card.Body>
                    </Card>
                    <Card className={s.filterCard}>
                        <Card.Title className={s.filterCardHeader}>
                            <div className={s.filterCardTitle}>Filter Meetings</div>
                            <div className={s.filterCardFilterToggle}>
                                <Button className={`btnLink`}
                                        onClick={toggleFilter}>{filerOpen ? 'Close' : 'Edit'}</Button>
                            </div>
                        </Card.Title>
                        <div className={s.mobile}>
                            {filerOpen &&
                                <>
                                    <Card.Body className={'my-0'}>
                                        <Button className={`${s.topicButton} ${topic === '' ? s.active : ''}`}
                                                onClick={updateTopic} value={''}>All Meetings</Button>
                                        {[].map((blogTopic, idx) =>
                                            <Button key={idx}
                                                    className={`${s.topicButton} ${topic === blogTopic.trim().toLowerCase().replaceAll(' ', '-') ? s.active : ''}`}
                                                    onClick={updateTopic}
                                                    value={blogTopic.trim().toLowerCase().replaceAll(' ', '-')}>{blogTopic.trim()}</Button>
                                        )}
                                    </Card.Body>
                                </>
                            }
                        </div>
                        <div className={s.desktop}>
                            <Card.Body className={'my-1'}>
                                <Button className={`${s.topicButton} ${topic === '' ? s.active : ''}`}
                                        onClick={updateTopic} value={''}>All Meetings</Button>
                                {[].map((blogTopic, idx) =>
                                    <Button key={idx}
                                            className={`${s.topicButton} ${topic === blogTopic.trim().toLowerCase().replaceAll(' ', '-') ? s.active : ''}`}
                                            onClick={updateTopic}
                                            value={blogTopic.trim().toLowerCase().replaceAll(' ', '-')}>{blogTopic.trim()}</Button>
                                )}
                            </Card.Body>
                        </div>
                    </Card>
                </aside>
            </div>
        </SideBar>
    </div>
}

export default (UserDashboard);
